import { render, staticRenderFns } from "./Rankings.vue?vue&type=template&id=e9e620ca&"
import script from "./Rankings.vue?vue&type=script&lang=js&"
export * from "./Rankings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports